@let availableTimeZones = availableTimeZones$ | async;
<blaze-select
  #timezoneSelector
  class="input-tag"
  autocompletePosition="auto"
  [options]="availableTimeZones || []"
  [multiselect]="false"
  [filtered]="true"
  [showNoneOption]="false"
  [closeDropdownOnSelect]="true"
  [selectedTemplateRef]="timeZoneTpl"
  [value]="formControl.value"
  [panelWidth]="320"
  (valueChange)="setTimezone($event)"
/>

<ng-template #timeZoneTpl let-selectedItems let-onDeselect="onDeselect">
  @for (item of selectedItems; track item.label) {
    <div
      class="chip-option"
      [style.background]="item.backgroundColor"
      [style.color]="'var(--primary-darker-color)'"
    >
      <span class="whitespace-normal">{{ item.label }}</span>
      <button class="deselect-button" (click)="onDeselect(item)">
        <mat-icon svgIcon="icon_close_8" />
      </button>
    </div>
  }
</ng-template>
